import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'vex-reg-sub-info',
  templateUrl: './reg-sub-info.component.html',
  styleUrls: ['./reg-sub-info.component.scss']
})
export class RegSubInfoComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'], private sanitizer: DomSanitizer) { }

  ngOnInit() {

  }

}
